var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "200px",
    height: "200px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#cecece",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.56,2.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 29,
    r: 2,
    fill: "#ee3e54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 13,
    r: 1,
    fill: "#f1bc19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 37,
    fill: "#fce0a2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 15,
    r: 4,
    fill: "#f1bc19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 24,
    r: 2,
    fill: "#ee3e54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 76,
    r: 2,
    fill: "#fbcd59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 63,
    r: 4,
    fill: "#fbcd59"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 87,
    r: 2,
    fill: "#ee3e54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 54.5,
    r: 2.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 67,
    r: 1,
    fill: "#f1bc19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 34,
    r: 1,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.719,73h-31.438c-4.021,0 -7.281,-3.26 -7.281,-7.281v-31.438c0,-4.021 3.26,-7.281 7.281,-7.281h31.438c4.021,0 7.281,3.26 7.281,7.281v31.438c0,4.021 -3.26,7.281 -7.281,7.281z",
    fill: "#e1e0d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.719,73.7h-31.438c-4.401,0 -7.981,-3.58 -7.981,-7.981v-31.438c0,-4.401 3.581,-7.981 7.981,-7.981h31.438c4.401,0 7.981,3.58 7.981,7.981v31.438c0,4.401 -3.58,7.981 -7.981,7.981zM35.281,27.7c-3.629,0 -6.581,2.952 -6.581,6.581v31.438c0,3.629 2.952,6.581 6.581,6.581h31.438c3.629,0 6.581,-2.952 6.581,-6.581v-31.438c0,-3.629 -2.952,-6.581 -6.581,-6.581z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,40.167c-0.276,0 -0.5,-0.224 -0.5,-0.5v-4.333c0,-2.941 2.393,-5.334 5.333,-5.334h14c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5h-14c-2.389,0 -4.333,1.944 -4.333,4.333v4.333c0,0.277 -0.224,0.501 -0.5,0.501z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.583,70h-6.25c-2.94,0 -5.333,-2.393 -5.333,-5.333v-20.334c0,-0.276 0.224,-0.5 0.5,-0.5c0.276,0 0.5,0.224 0.5,0.5v20.333c0,2.39 1.944,4.334 4.333,4.334h6.25c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.223,0.5 -0.5,0.5z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.667,70h-19.75c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5h19.75c2.39,0 4.333,-1.944 4.333,-4.333v-5.083c0,-0.276 0.224,-0.5 0.5,-0.5c0.276,0 0.5,0.224 0.5,0.5v5.083c0,2.94 -2.393,5.333 -5.333,5.333z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5,56.167c-0.276,0 -0.5,-0.224 -0.5,-0.5v-20.334c0,-2.389 -1.943,-4.333 -4.333,-4.333h-2.75c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5h2.75c2.94,0 5.333,2.393 5.333,5.333v20.333c0,0.277 -0.224,0.501 -0.5,0.501z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,31h-6.25c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-0.276 0.224,-0.5 0.5,-0.5h6.25c0.276,0 0.5,0.224 0.5,0.5c0,0.276 -0.224,0.5 -0.5,0.5z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.636,41.936l-2.189,-3.788c-0.28,-0.408 -0.742,-0.652 -1.237,-0.652h-6.419c-0.495,0 -0.958,0.244 -1.237,0.652l-2.189,3.788c-0.28,0.408 -0.742,0.652 -1.237,0.652h-4.378c-1.243,0 -2.25,1.007 -2.25,2.25v15.416c0,1.243 1.007,2.25 2.25,2.25h24.5c1.243,0 2.25,-1.007 2.25,-2.25v-15.416c0,-1.243 -1.007,-2.25 -2.25,-2.25h-4.376c-0.495,0 -0.958,-0.244 -1.238,-0.652z",
    fill: "#7c8a9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.25,63.004h-24.5c-1.517,0 -2.75,-1.234 -2.75,-2.75v-15.416c0,-1.517 1.233,-2.75 2.75,-2.75h4.377c0.329,0 0.638,-0.163 0.825,-0.436l2.168,-3.754c0.394,-0.578 1.011,-0.903 1.671,-0.903h6.418c0.659,0 1.276,0.325 1.65,0.87l2.198,3.802c0.188,0.264 0.491,0.421 0.815,0.421h4.377c1.517,0 2.75,1.233 2.75,2.75v15.416c0.001,1.517 -1.232,2.75 -2.749,2.75zM38.75,43.088c-0.965,0 -1.75,0.785 -1.75,1.75v15.416c0,0.965 0.785,1.75 1.75,1.75h24.5c0.965,0 1.75,-0.785 1.75,-1.75v-15.416c0,-0.965 -0.785,-1.75 -1.75,-1.75h-4.377c-0.659,0 -1.276,-0.325 -1.649,-0.87l-0.021,-0.033l-2.188,-3.787c-0.167,-0.24 -0.476,-0.403 -0.806,-0.403h-6.418c-0.33,0 -0.639,0.163 -0.826,0.436l-2.168,3.754c-0.395,0.578 -1.011,0.903 -1.67,0.903z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51.5,
    r: 7.5,
    fill: "#ededeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,59.5c-4.411,0 -8,-3.588 -8,-8c0,-4.412 3.589,-8 8,-8c4.411,0 8,3.589 8,8c0,4.411 -3.589,8 -8,8zM51,44.5c-3.859,0 -7,3.14 -7,7c0,3.859 3.141,7 7,7c3.859,0 7,-3.14 7,-7c0,-3.859 -3.141,-7 -7,-7z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51.5,
    r: 5.042,
    fill: "#7c8a9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,57.042c-3.056,0 -5.542,-2.486 -5.542,-5.542c0,-3.056 2.486,-5.542 5.542,-5.542c3.056,0 5.542,2.486 5.542,5.542c0,3.056 -2.486,5.542 -5.542,5.542zM51,46.958c-2.505,0 -4.542,2.038 -4.542,4.542c0,2.504 2.037,4.542 4.542,4.542c2.505,0 4.542,-2.037 4.542,-4.542c0,-2.505 -2.037,-4.542 -4.542,-4.542z",
    fill: "#472b29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 46.5,
    r: 1.5,
    fill: "#fbcd59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,48.25c-0.965,0 -1.75,-0.785 -1.75,-1.75c0,-0.965 0.785,-1.75 1.75,-1.75c0.965,0 1.75,0.785 1.75,1.75c0,0.965 -0.785,1.75 -1.75,1.75zM61.5,45.25c-0.689,0 -1.25,0.561 -1.25,1.25c0,0.689 0.561,1.25 1.25,1.25c0.689,0 1.25,-0.561 1.25,-1.25c0,-0.689 -0.561,-1.25 -1.25,-1.25z",
    fill: "#472b29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.5,40.476h-4.125v-1.234c0,-0.455 0.37,-0.825 0.825,-0.825h2.475c0.455,0 0.825,0.37 0.825,0.825z",
    fill: "#7c8a9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,40.976h-4.125c-0.276,0 -0.5,-0.224 -0.5,-0.5v-1.234c0,-0.731 0.595,-1.325 1.325,-1.325h2.475c0.73,0 1.325,0.594 1.325,1.325v1.234c0,0.276 -0.224,0.5 -0.5,0.5zM38.875,39.976h3.125v-0.734c0,-0.179 -0.146,-0.325 -0.325,-0.325h-2.475c-0.18,0 -0.325,0.146 -0.325,0.325z",
    fill: "#472b29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.60db68cb0e85ff60f3c3279792f6b255.svg";
export { ForwardRef as ReactComponent };